// #region import
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './messages/en.json'
// #endregion

// #region init
Vue.use(VueI18n)
// #endregion

// #region export
export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: en,
  },
})
// #endregion